import React from 'react';
import { Link } from 'react-router-dom';
import { Dumbbell, MapPin, Phone, Mail, Facebook, Instagram, Twitter } from 'lucide-react';
import { gymInfo } from '../mock';

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-sky-500/20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_nex-fitness/artifacts/fe6c6al4_21cb23e127dab1f224d594232e53537a.jpg" 
                alt="NEX Level Gym" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm mb-4">
              {gymInfo.tagline}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-sky-400 transition-colors duration-300">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-sky-400 transition-colors duration-300">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-sky-400 transition-colors duration-300">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-sky-400 text-sm transition-colors duration-300">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/membresias" className="text-gray-400 hover:text-sky-400 text-sm transition-colors duration-300">
                  Membresías
                </Link>
              </li>
              <li>
                <Link to="/profesores" className="text-gray-400 hover:text-sky-400 text-sm transition-colors duration-300">
                  Profesores
                </Link>
              </li>
              <li>
                <Link to="/horarios" className="text-gray-400 hover:text-sky-400 text-sm transition-colors duration-300">
                  Horarios
                </Link>
              </li>
              <li>
                <Link to="/testimonios" className="text-gray-400 hover:text-sky-400 text-sm transition-colors duration-300">
                  Testimonios
                </Link>
              </li>
            </ul>
          </div>

          {/* Horarios */}
          <div>
            <h3 className="text-white font-semibold mb-4">Horarios</h3>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-400">{gymInfo.hours.weekdays}</li>
              <li className="text-gray-400">{gymInfo.hours.saturday}</li>
              <li className="text-gray-400">{gymInfo.hours.sunday}</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm">
                <MapPin className="h-5 w-5 text-sky-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400">{gymInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3 text-sm">
                <Phone className="h-5 w-5 text-sky-400 flex-shrink-0" />
                <a href={`tel:${gymInfo.phone}`} className="text-gray-400 hover:text-sky-400 transition-colors duration-300">
                  {gymInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3 text-sm">
                <Mail className="h-5 w-5 text-sky-400 flex-shrink-0" />
                <a href={`mailto:${gymInfo.email}`} className="text-gray-400 hover:text-sky-400 transition-colors duration-300">
                  {gymInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-sky-500/20 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} NEX Gym. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
